import { Box, Flex, Stack } from "@chakra-ui/react";
import { Navbar } from "./Navbar";
import { Sidebar } from "./Sidebar";
import { Toaster } from "react-hot-toast";
import PropTypes from "prop-types";

const RootLayout = ({ children }) => {
  return (
    <Box h={"100vh"} bg={"gray.100"}>
      <Toaster />
      <Navbar />
      <Flex h={"100vh"}>
        <Sidebar />
        <Stack w={"100%"} overflow={"auto"} pt={12}>
          {children}
        </Stack>
      </Flex>
    </Box>
  );
};
RootLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { RootLayout };
